<template>
	<view class="container ">
	  <view class="indexed bgf">
	    <view class="initial">
	      <block v-for="item in initials" :key="item">
	        <view class="inl" :data-inl="item" @tap="inlTap" :style="{height:inlsH +'px', lineHeight:inlsH+'px'}">{{item}}</view>
	      </block>
	    </view>
	    <scroll-view :scroll-into-view="viewInl" scroll-y="true" class="inner" :style="{height:indexedH+'px'}">
	      <block v-for="(item, inl) in brands" :key="inl">
	        <view class="inner-group" :id="inl">{{inl}}</view>
	        <block v-for="brand in item" :key="brand.brand_id">
	          <navigator :url="'/pages/model/model?level=L0&brand_id=' + brand.brand_id">
	            <view class="inner-item">{{brand.brand_name}}</view>
	          </navigator>
	        </block>
	      </block>
	    </scroll-view>
	  </view>
	</view>
</template>

<script>
	const app = getApp();
	export default {
		data() {
			return {
				initials:[],
				inlsH: 50,
				viewInl: 'A',
				indexedH:100,
				brands:{}
			}
		},
		onLoad(option) {
			var that = this;
			app.getApi('GET', 'gzh/getGzhBrand', {}, 1, function (data) {
				var initials = new Array();
				var brands = {};
				var lastInitial = '';
				for(var i in data)
				{
					var initial = data[i].brand_initial.substring(0, 1);
					if (lastInitial != initial){
						initials.push(initial);
						brands[initial] = new Array();
						lastInitial = initial;
					}
					brands[initial].push(data[i]);
				}
				uni.getSystemInfo({
					success(sys) {
						that.initials = initials;
						that.brands = brands;
						that.inlsH = initials.length > 0 ? sys.windowHeight / initials.length : 50;
						that.indexedH = sys.windowHeight;
					}
				})
			});
		},
		methods: {
			inlTap:function(e){
			    this.viewInl = e.currentTarget.dataset.inl;
			}
		}
	}
</script>

<style>
.indexed .initial{
    position: absolute;
    height: 100%;
    z-index: 10;
    right: 0px;
    width: 60rpx;
    background-color: lightgrey;
}
.indexed .initial>.inl{
  text-align: center;
  color: #888888;
}
.indexed .inner{height:100px}
.indexed .inner-group{
  padding:8px 16px;
  background-color: #f7f7f7;
  font-weight: 500;
  margin-top: -1px;
  margin-left: 0;
  color: #888888;
}
.indexed .inner-item{
  padding: 12px 16px;
  border-bottom: 1px solid #eee;
}

</style>
